import styled from 'styled-components';

export const DescriptionContainer = styled.div`
  justify-content: center;
  flex-direction: column;
  align-content: center;
  align-items: center;
  text-align: center;

  display: flex;
  height: 100%;
  width: 100%;

  h2 {
    margin-bottom: 5vmax;
    max-width: 85%;
  }

  em {
    font-size: 0.8rem;
  }
`;

export const ErrorDescription = styled.div`
  margin-bottom: 5vmax;

  strong {
    margin-bottom: 1rem;
    font-style: italic;
    font-size: 1.25rem;
  }

  span,
  strong {
    position: relative;
    display: block;
  }
`;
